// Stack story episodes: each series shows once (latest episode) in the grid; merged "Full Series" videos stay separate
export const groupSeries = (videos) => {
  const stacks = {};
  videos.forEach((v) => {
    if (!v.series_id || v.is_series_merge) return;
    (stacks[v.series_id] ||= { id: v.series_id, title: v.series_title || v.title, episodes: [] }).episodes.push(v);
  });
  Object.values(stacks).forEach((s) => s.episodes.sort((a, b) => (a.episode_number || 1) - (b.episode_number || 1)));
  const shown = new Set();
  const display = videos.filter((v) => {
    const s = !v.is_series_merge && v.series_id && stacks[v.series_id];
    if (!s || s.episodes.length < 2) return true;
    if (shown.has(v.series_id)) return false;
    shown.add(v.series_id);
    return true;
  });
  return { stacks, display };
};
